const WLADDRESS = "0xDF3A8B34122580a1F61D8382E68687524798a422"

export default WLADDRESS
